/**
 * src/components/NavTabIcon.jsx — TICKET-1098.
 *
 * A nav tab's icon plus its attention count. Today only Pipeline carries one: the
 * number of quotes waiting for review (usePendingReviews), so the CEO sees them
 * from any tab. Shared by all four NavigationShell layouts so they never disagree.
 */
import usePendingReviews from '../lib/hooks/usePendingReviews';
import { useT } from '../lib/i18n/I18nContext';

const BADGE_STYLE = {
  position: 'absolute', top: -6, right: -10, minWidth: 18, height: 18, padding: '0 5px',
  borderRadius: 99, background: 'var(--bad)', color: 'var(--inv)', fontSize: 10, fontWeight: 700,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', lineHeight: 1,
};

export default function NavTabIcon({ tab, Icon, ...iconProps }) {
  const { count } = usePendingReviews();
  const { t } = useT();
  const n = tab === 'pipeline' ? count : 0;
  return (
    <span style={{ position: 'relative', display: 'inline-flex' }}>
      <Icon {...iconProps} />
      {n > 0 && (
        <span data-testid={`nav-badge-${tab}`} role="status" aria-label={t('quoteReview.navCount', { count: n })} style={BADGE_STYLE}>
          {n > 99 ? '99+' : n}
        </span>
      )}
    </span>
  );
}
